module.exports = __webpack_public_path__ + "ef8a33458b93bf199943d4f35460d20a.MP3";